import React from 'react';
import ShopItem from "../Shop-item/ShopItem";
import Aux from "../../utils/auxilary";
import './ShopItems.scss';

const itemsInRow = 6;

const ShopItems = ({ shopsObject, title, staticImagePrefix, showCount, isPrivate, isOtherLocationShop, isPublic, isBranded }) => {
    const { shops, count } = shopsObject;
    let numberOfStaticItems = 6;

    if (count > 0) {
        numberOfStaticItems = count % itemsInRow === 0 ? 0 : (itemsInRow - (count % itemsInRow));
    }

    const renderStaticShops = () => {
        const staticShop = {
            display_name: 'Static'
        };
        return Array.from(Array(numberOfStaticItems).keys()).map(num => (
            <ShopItem staticImagePrefix={staticImagePrefix} shop={staticShop}
                staticImageIndex={num + 1 + (itemsInRow - numberOfStaticItems)} key={num} isStatic={true} />
        ));
    };

    const sectionMeta = isPrivate
        ? { heading: 'Your Favourite Shops', subtitle: 'Purchase products from your favourite shop' }
        : isPublic
            ? { heading: 'Public Shops', subtitle: 'Find the lowest price for the products from different shops' }
            : isBranded
                ? { heading: 'Branded Shops', subtitle: 'Popular brands and exclusive deals' }
                : isOtherLocationShop
                    ? { heading: 'Shops from Other Locations', subtitle: 'Browse stores beyond your neighbourhood' }
                    : { heading: title, subtitle: '' };

    const tooltipText = isPrivate
        ? 'Purchase products from your favourite shop'
        : isPublic
            ? 'Find the lowest price for the products from different shops'
            : isBranded
                ? 'Find the branded products in best deals'
                : isOtherLocationShop
                    ? 'Find the global products in best deals'
                    : null;

    return (
        <Aux>
            <section className="home-shop-section">
                <div className="home-shop-section-header shops-group">
                    <div>
                        <h2 className="home-shop-section-title">{sectionMeta.heading}</h2>
                        {sectionMeta.subtitle ? (
                            <p className="home-shop-section-subtitle">{sectionMeta.subtitle}</p>
                        ) : null}
                    </div>
                    {tooltipText ? (
                        <div className="btn-group dropup ml-2">
                            <button type="button" className="btn btn-light p-0 ml-2 tooltip-btn"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i className="fal fa-question-circle align-self-center cursor-pointer" />
                            </button>
                            <div className="dropdown-menu width-200px px-2 font-size-2">
                                <span>{tooltipText}</span>
                            </div>
                        </div>
                    ) : null}
                </div>
                <div className='row home-shop-grid'>
                    {shops.map(shop => {
                        return <ShopItem shop={shop} key={shop.stores[0]} showCount={showCount} isPrivate={isPrivate}
                            isOtherLocationShop={isOtherLocationShop} />
                    })}
                    {renderStaticShops()}
                </div>
            </section>
        </Aux>
    );
};
export default ShopItems;
